var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('promocode',{staticClass:"flex-grow",on:{"validated":function (ref) {
	var originalPromocode = ref.originalPromocode;

	return (this$1.promocode = originalPromocode);
},"removed":function () { return (this$1.promocode = null); }}}),(_vm.promocode)?_c('btn',{staticClass:"bg-green text-white ml-6 px-6",on:{"click":_vm.applyPromocode}},[_vm._v(" "+_vm._s(_vm.$config("APPLY"))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }